module.exports = __webpack_public_path__ + "img/new-mail.d867347b.svg";